import { TextArea } from '@dealstack/frontend/shared/components/forms/TextArea/TextArea';
import { ButtonsRight } from '@dealstack/frontend/shared/components/fundament/Button/ButtonLayouts';
import {
	CancelButton,
	SaveButton,
} from '@dealstack/frontend/shared/components/fundament/Button/CommonButtons';
import { Modal, ModalBox } from '@dealstack/frontend/shared/components/fundament/Modal/Modal';
import { SectionHeader } from '@dealstack/frontend/shared/components/SectionHeader/SectionHeader';
import { useTranslationMipCreate } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';
import styled from 'styled-components';

interface Props {
	className?: string;
	onClose: () => void;
	rowIndex: number;
	onSave: () => void;
	onCancel: () => void;
}

const InvestorInstructionsModal = ({ className, onClose, rowIndex, onSave, onCancel }: Props) => {
	const tMipCreate = useTranslationMipCreate();

	return (
		<Modal onClose={onClose} size="sm" className={className} closeButton={false}>
			<SectionHeader
				title={tMipCreate('contracts.modals.investors.title')}
				subtitle={tMipCreate('contracts.modals.investors.subtitle')}
				size="h4b"
			/>
			<TextArea
				data-testid={TEST_ELEMENT_IDS.MIP_CREATE_CONTRACTS_INSTRUCTIONS_TO_INVESTORS_INPUT}
				name={`contracts.${rowIndex}.instruction`}
				rows={5}
				fullWidth
			/>
			<CounterpartiesModalButtons gap="md">
				<CancelButton
					data-testid={
						TEST_ELEMENT_IDS.MIP_CREATE_CONTRACTS_INSTRUCTIONS_TO_INVESTORS_CANCEL_BUTTON
					}
					onClick={onCancel}
				/>
				<SaveButton
					data-testid={
						TEST_ELEMENT_IDS.MIP_CREATE_CONTRACTS_INSTRUCTIONS_TO_INVESTORS_SAVE_BUTTON
					}
					onClick={onSave}
				/>
			</CounterpartiesModalButtons>
		</Modal>
	);
};

const CounterpartiesModalButtons = styled(ButtonsRight)`
	padding-top: 2em;
`;

const Styled = styled(InvestorInstructionsModal)`
	${TextArea} {
		margin-top: 2.5em;
	}
	${ModalBox} {
		width: 33rem;
	}
`;

export { Styled as InvestorInstructionsModal };
